import * as React from "react"
import { graphql } from "gatsby"
import Layout from "../wrappers/layout"
import Seo from "../components/seo"
import Feature from "../components/feature"
import Link from "../components/link"

const IndexPage = ({ data }) => {

  return (
    <Layout>
      <ul className="thumbnails mbx4">
        {data?.allFeatures?.nodes?.map((node, i) => (
          <li className={i === 0 ? 'highlight' : ''} key={`indexpage-${i}-${node.slug}`}>
            <Feature {...node} isHighlight={i === 0} />
          </li>
        ))}
      </ul>
      <div className="guttersx2 align-center outerx4">
        <Link to="/archive" className="btn">Browse Archive</Link>
      </div>
    </Layout>
  )
}

/**
 * Head export to define metadata for the page
 *
 * See: https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-head/
 */
export const Head = () => <Seo />

export default IndexPage

export const pageQuery = graphql`
  query IndexPageQuery {
    allFeatures: allContentfulFeature (
      limit: 25
      sort: { publishedAt: DESC }
    ) {
      nodes {
        ...Feature
      }
    }
  }
`